<template>
    <div class="modal fade bd-imprint-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <!--Content-->
            <div class="modal-content">
                <!--Header-->
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel">Impressum</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <!--Body-->
                <div class="modal-body">
                    
                    <h5>Heimann.s Agentur</h5>
                    <p>Sylvia Heimann<br>
                    c/o RIWAS 12<br>
                    Richard-Wagner-Str. 12<br>
                    50674 Köln</p>
                    <p>
                    Email:info(at)heimanns-agentur.de<br>
                    Telefon: 0221 / 846 91-20 <br>
                    Telefax: 0221 / 846 91-19</p>

                    <p>Finanzamt Köln-Altstadt<br>
                    Umsatzsteuer-ID-Nr. DE257476682</p>
                    
                    <p>Inhaltlich Verantwortliche gemäß § 55 RStV: Sylvia Heimann</p>

                    <p>
                        Diese Seiten sind Teil von Heimann.s Agentur. Verantwortlich für Inhalt und Darstellung ist:
                    </p>
                    <p>Sylvia Heimann<br>
                    c/o RIWAS 12<br>
                    Richard-Wagner-Str. 12<br>
                    50674 Köln</p>
                    <p>
                    Email:info(at)heimanns-agentur.de<br>
                    Telefon: 0221 / 846 91-20 <br>
                        Telefax: 0221 / 846 91-19</p>
                    
                    <h5>Konzept und Ideen</h5>
                    <p>Jochen Alexander Wigand, Sylvia Heimann, Kai Müller</p>
                    
                    <h5>Programmierung</h5>
                    <p>Kai Müller: <a style="color:#0188c0;" href="http://www.kai-mueller.info">http://www.kai-mueller.info</a></p>
                    
                    <h5>Haftungsausschluß</h5>
                    <p>
                        1. Inhalt des Onlineangebotes<br/>
                        Heimann.s Agentur (Autor) und die Informationszubringer sind stets bemüht, qualitativ hochwertige Informationen zur Verfügung zu stellen. Trotzdem übernimmt Autor keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen Autoren, die sich auf Schäden materieller oder ideeller Art beziehen, welche durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden sind grundsätzlich ausgeschlossen, sofern seitens Autor kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle Angebote sind frei bleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
                    </p>

                    <p>
                        2. Verweise und Links<br/>
                        Sofern auf Verweisziele ("Links") direkt oder indirekt verwiesen wird, die außerhalb des Verantwortungsbereiches von Autor liegen, entstehen daraus für Autor keinerlei Haftungsansprüche. Für die Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter dieser Seiten, nicht derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist. Diese Einschränkung gilt gleichermaßen auch für Fremdeinträge in von Autor eingerichteten Gästebüchern, Diskussionsforen und Mailinglisten.
                    </p>
                    <p>
                        3. Urheberrecht<br/>
                        Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind! Das Copyright für veröffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim Autor der Seiten. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Autors nicht gestattet.
                    </p>
                     <p>
                        4. Rechtswirksamkeit dieses Haftungsausschlusses<br/>
                        Dieser Haftungsausschluss ist Teil des Internetangebots www.heimanns-agentur.de. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.
                    </p>
                    <p>© Heimann.s Agentur 2026
                    </p>
                 </div>
            </div>
            <!--/.Content-->
        </div>
    </div>
  
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Imprint.vue